module.exports = __webpack_public_path__ + "img/46.39ed5037.jpg";